import React, { useState, useRef } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const GOOGLE_MAPS_API_KEY = "AIzaSyDLELugT8IRdEiIhg8BNbrRXX7oCq7gSgQ";

const mapContainerStyle = {
    width: '100%',
    height: '100%',
    borderRadius: '0.5rem',
    overflow: 'hidden',
    boxShadow: '0 0 8px rgba(0, 0, 0, 0.1)'
};

const defaultCenter = {
    lat: 40.0,
    lng: -89.0,
};

const MAX_ZOOM = 15;

export default function ListingsMap({ listings }) {
    const [corners, setCorners] = useState(null);
    const mapRef = useRef(null);

    const mapOptions = {
        maxZoom: MAX_ZOOM,
        zoomControl: true,
        scrollwheel: true,
        gestureHandling: 'auto',
        streetViewControl: false, // Disable Street View control
    };

    const onMapLoad = (map) => {
        mapRef.current = map;
        updateCorners(map);
    };

    const updateCorners = (map) => {
        const bounds = map.getBounds();
        if (!bounds) return;

        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();

        const topLeft = { lat: ne.lat(), lng: sw.lng() };
        const topRight = { lat: ne.lat(), lng: ne.lng() };
        const bottomLeft = { lat: sw.lat(), lng: sw.lng() };
        const bottomRight = { lat: sw.lat(), lng: ne.lng() };

        setCorners({ topLeft, topRight, bottomLeft, bottomRight });
    };

    return (
        <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
            <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={defaultCenter}
                zoom={7}
                options={mapOptions}
                onLoad={onMapLoad}
                onIdle={() => {
                    if (mapRef.current) {
                        updateCorners(mapRef.current);
                    }
                }}
            >
                {listings.map((listing, idx) => {
                    const lat = listing?.location?.lat;
                    const lng = listing?.location?.lon;

                    return lat && lng ? (
                        <Marker
                            key={listing.id || idx}
                            position={{ lat, lng }}
                        />
                    ) : null;
                })}
            </GoogleMap>
            {corners && (
                <pre style={{ padding: '1rem', background: '#fff' }}>
                    {JSON.stringify(corners, null, 2)}
                </pre>
            )}
        </LoadScript>
    );
}